import { useEffect } from 'react';

/**
 * Hook minimaliste pour marquer une page comme `noindex, nofollow`.
 * Utilisé sur les pages privées (auth, admin, paywall) pour empêcher
 * leur indexation par Google et consorts.
 *
 * Complémentaire au `Disallow` du robots.txt (un crawler peut ignorer
 * robots.txt ; une meta noindex au niveau HTML est plus contraignante).
 */
export function useNoIndex() {
  useEffect(() => {
    let meta = document.head.querySelector('meta[name="robots"]');
    const previous = meta ? meta.getAttribute('content') : null;
    const wasCreated = !meta;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'noindex, nofollow, noarchive');
    return () => {
      if (!meta) return;
      if (wasCreated) {
        meta.remove();
      } else if (previous != null) {
        meta.setAttribute('content', previous);
      }
    };
  }, []);
}

export default useNoIndex;
